import React from "react";
import PropTypes from "prop-types";
import Str from "shared/components/Str";
import _str from "shared/util/_str";
import { RECAPTCHA_SITE_KEY } from "shared/util/constants";
import ReCAPTCHA from "react-google-recaptcha";
import classnames from "classnames";
import OkInput from "shared/components/oknf/OkInput";

import "./LoginCaptcha.scss";

class WebviewCaptchaLogin extends React.Component {
	static propTypes = {
		submitLogin: PropTypes.func.isRequired,
		changeField: PropTypes.func.isRequired,
		isSubmitting: PropTypes.bool.isRequired,
		isLoggedIn: PropTypes.bool.isRequired,
		username: PropTypes.string,
		password: PropTypes.string,
		captchaKey: PropTypes.string,
		onCaptchaVerify: PropTypes.func.isRequired,
		isLoggingIn: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		username: "",
		password: "",
		captchaKey: "",
	};

	_formatSignInCopy = () => {
		const { isLoggedIn, isLoggingIn } = this.props;

		if (isLoggedIn) {
			return _str("Success!");
		}

		if (isLoggingIn) {
			return _str("Submitting…");
		}

		return _str("Sign In");
	}

	_onChangeUsername = (ev) => {
		this.props.changeField("username", ev.target.value);
	};

	_onChangePassword = (ev) => {
		this.props.changeField("password", ev.target.value);
	};

	_submitLogin = (ev) => {
		ev.preventDefault();

		// do nothing if we're submitting already
		if (this.props.isSubmitting) {
			return false;
		}

		// blur the inputs, if the refs exist
		["username", "password"].forEach((field) => {
			if (this[field] && typeof (this[field].blur) === "function") {
				this[field].blur();
			}
		});

		// actually submit
		this.props.submitLogin();

		return null;
	};

	renderCaptcha = () => {
		const { onCaptchaVerify } = this.props;

		return (
			<div className="login-fields">
				<div className="login-captcha login-fields">
					<ReCAPTCHA
						sitekey={RECAPTCHA_SITE_KEY}
						onChange={onCaptchaVerify}
					/>
				</div>
			</div>
		);
	}

	render() {
		const {
			username,
			password,
			isSubmitting,
			isLoggedIn,
			captchaKey,
		} = this.props;

		const signInDisabled = !username || !password || !captchaKey;

		return (
			<form
				onSubmit={this._submitLogin}
				className="oknf oknf--gray login-form"
				method="POST"
			>
				<div className="login-fields">
					<div className="login-fields-field">
						<Str className="login-fields-field-label">Email</Str>
						<OkInput
							name="username"
							value={username}
							placeholder="Email"
							autoComplete="off"
							autoCorrect="off"
							autoCapitalize="off"
							autoFocus={process.env.PLATFORM === "desktop"}
							spellCheck="false"
							className="login-fields-field-input login-username"
							onChange={this._onChangeUsername}
						/>
					</div>

					<div className="login-fields-field">
						<Str className="login-fields-field-label">Password</Str>
						<OkInput
							name="password"
							type="password"
							placeholder="Password"
							value={password}
							className="login-fields-field-input login-password"
							onChange={this._onChangePassword}
						/>
					</div>
				</div>

				{this.renderCaptcha()}

				<div className="login-actions">
					<input
						type="submit"
						value={this._formatSignInCopy()}
						disabled={signInDisabled}
						className={classnames("login-actions-button", {
							"isSubmitting": isSubmitting,
							"isloggedin": isLoggedIn,
						})}
					/>
				</div>
			</form>
		);
	}
}

export default WebviewCaptchaLogin;



// WEBPACK FOOTER //
// ./src/apps/login/components/screens/WebviewCaptchaLogin.jsx